import { Box, GridItem, Icon, Typography } from "@drone-js/core";
import { type ReactNode, memo } from "react";

interface CheckedItemProps {
    title: string;
    description: ReactNode;
}

export const CheckedItem = memo<CheckedItemProps>(({ title, description }) => (
    <GridItem sm={12}>
        <Box
            display="flex"
            qM={{
                alignItems: "center",
            }}
        >
            <Icon id="fill.symbol.check" size="16" />
            <Box
                display="flex"
                ms="12"
                flexDirection="column"
                qM={{
                    mb: "-4",
                    flexDirection: "row",
                }}
            >
                <Typography variant="body-default-strong" textColor="base.default" mb="4" me="4">
                    {title}
                </Typography>
                <Typography variant="body-default" textColor="base.subtle">
                    {description}
                </Typography>
            </Box>
        </Box>
    </GridItem>
));
